var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgThumbup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 136 136"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 68,
  r: 67.709,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#008EDE",
  fillRule: "evenodd",
  d: "M97.482 56.768c.834 0 1.623.371 2.156 1.008.531.64.756 1.483.607 2.303l-5.616 30.887a2.811 2.811 0 0 1-2.763 2.305H69.403c-.356 0-.713-.068-1.041-.2l-10.19-4.074V62.384l8.65-17.956a2.806 2.806 0 0 1 2.581-1.699h8.424a2.807 2.807 0 0 1 2.808 2.808v11.231h16.847Zm-58.965 2.808h11.231a2.807 2.807 0 0 1 2.808 2.808v28.079a2.807 2.807 0 0 1-2.808 2.808H38.517a2.807 2.807 0 0 1-2.808-2.808V62.384a2.807 2.807 0 0 1 2.808-2.808Z",
  clipRule: "evenodd"
})));
export default SvgThumbup;